/*
 * Полоса состояния. Из макета «Оболочка - этап 0», раздел трёх служебных полос.
 *
 * ПОЛОСА — ЭТО СОСТОЯНИЕ ЭКРАНА, А НЕ ВСПЛЫВАЮЩЕЕ СООБЩЕНИЕ: она не исчезает сама
 * и не заслоняет содержимое, а занимает свою строку сверху.
 */

/*
 * Обёртка объявлена контейнером, и переключение «широкая — узкая» сделано запросом
 * к контейнеру, а НЕ медиазапросом по ширине экрана.
 *
 * Причина не в моде на новый синтаксис. Полоса бывает узкой не только на телефоне:
 * она же стоит в рамке телефона мастера на витрине /ui, в предпросмотре и в боковой
 * панели — всё это на экране 1366, где медиазапрос молчит. Полоса обязана смотреть
 * на СВОЮ ширину, а не на ширину окна, иначе предупреждение «изменения сейчас
 * не сохраняются» окажется обрезанным ровно там, где его и надо прочесть.
 */
.host {
  container-type: inline-size;
  display: block;
  flex: none;
}

.stripe {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: var(--stripe-height);
  padding: 0 var(--space-4);
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  min-width: 0;
}

.title {
  flex: none;
  font-weight: var(--font-weight-semibold);
}

.text {
  opacity: 0.9;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action {
  margin-left: auto;
  flex: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-weight: var(--font-weight-semibold);
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}

/*
 * В УЗКОМ МЕСТЕ ПОЛОСА НЕ ОБРЕЗАЕТ ТЕКСТ, А ПЕРЕНОСИТ ЕГО.
 * Так нарисовано в макете мастера: там у полосы нет фиксированной высоты, только
 * padding 7px 14px. Порог 620 px — ширина, ниже которой самая длинная из трёх строк
 * («Доступ ограничится 20 сентября. Напоминания клиентам продолжат уходить»)
 * перестаёт помещаться рядом с заголовком и действием.
 */
@container (max-width: 620px) {
  .stripe {
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 7px 14px;
    font-size: var(--font-size-sm);
    line-height: 1.35;
  }

  .text {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    flex: 1 1 100%;
  }

  .action {
    margin-left: 0;
  }
}

@media (pointer: coarse) {
  /* Действие в полосе — единственная кнопка на ней, промахнуться по ней нельзя. */
  .action {
    min-height: var(--touch-min-target);
  }
}

.offline {
  background: var(--stripe-offline-bg);
  color: var(--stripe-offline-fg);
}

.impersonate {
  background: var(--stripe-impersonate-bg);
  color: var(--stripe-impersonate-fg);
}

.billing {
  background: var(--stripe-billing-bg);
  color: var(--stripe-billing-fg);
}
